import axiosBaseApi from '../common/lib/axiosBaseApi';
import { TableSettings, TableSettingsFields, QuickActionButtons, Hotkeys } from './userSettingsTypes';

export const getTableSettingsRest = async () => {
  return await axiosBaseApi.get<TableSettings>(`/v1/settings/table`);
};

export const setTableSettingsRest = async ({
  setting,
  value,
}: {
  setting: TableSettingsFields;
  value: string | boolean | QuickActionButtons | Hotkeys;
}) => {
  return await axiosBaseApi.put<TableSettings>(`/v1/settings/table`, {
    [setting]: value,
  });
};
